<template>
  <div class="image-header" :style="{ '--image-height' : `${imgHeight}px` }" :class="[backgroundColor]">
    <div class="image" :style="imageStyle"/>
    <div class="image-header-content">
      <div :class="['title', {'with-overlay': hasOverlayContent}]">
        <action-button v-if="actionButtonProps" class="image-header-action-button" v-bind="actionButtonProps" @click="actionButtonProps.onClick"/>
        <span v-if="!hasHeaderSlot" class="ri-large-headline" :style="{ color: textColor }">{{ title }}</span>
        <slot v-else name="header"/>
      </div>
      <slot name="overlayContent"/>
      <separator v-if="bottomSeparator" class="margin-top-ml"/>
    </div>
  </div>
</template>

<script>
import Separator from './Separator.vue';
import Colors from '../scss/riseup-js-colors.module.scss';
import ActionButton from './ActionButton.vue';
import { BACKGROUND_POSITIONS, COLOR_VARIANT, COLOR_VARIANTS } from '../utils/layout-consts';

export const ImageHeaderProps = {
  title: {
    type: String,
    required: false,
  },
  backgroundColor: {
    type: String,
    default: COLOR_VARIANT.WHITE,
    validator: value => COLOR_VARIANTS.includes(value),
  },
  imgSrc: {
    type: String,
    required: false,
  },
  imgHeight: {
    type: Number,
    default: 240,
  },
  textColor: {
    type: String,
    default: Colors.riseupWhite,
  },
  bottomSeparator: {
    type: Boolean,
    default: true,
  },
  backgroundPosition: {
    type: String,
    required: false,
    validator: value => BACKGROUND_POSITIONS.includes(value),
  },
  actionButtonProps: {
    type: Object,
    required: false,
  },
};

export default {
  name: 'ImageHeader',
  components: {
    ActionButton,
    Separator,
  },
  props: ImageHeaderProps,
  computed: {
    hasHeaderSlot() {
      return !!this.$slots.header;
    },
    hasOverlayContent() {
      return !!this.$slots.overlayContent;
    },
    imageStyle() {
      return `background-image: url(${this.imgSrc}); background-position: ${this.backgroundPosition};`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/riseup-colors";
@import "../scss/spacings";
@import "../scss/riseup-z-index";

$card-top-offset: -30px;
.image-header {
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
  z-index: $top-banner;

  .image {
    position: absolute;
    top: 0;
    height: var(--image-height);
    width: 100%;
    z-index: 0;
    background-position: top;
    background-repeat: no-repeat;
  }

  .image-header-content {
    width: 100%;
    padding: 0 $ri-spacing-ml;
    z-index: 1;
    color: $riseup_white;

    .title {
      height: var(--image-height);
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      text-align: center;

      &.with-overlay {
        height: calc(var(--image-height) + $card-top-offset);
      }

      .image-header-action-button {
        position: absolute;
        top: $ri-spacing-ml;
        right: $ri-spacing-ml;
      }
    }
  }

  @each $variant, $color in $variant-to-color {
    &.#{$variant} {
      .image {
        background-color: $color;
      }
    }
  }
}

</style>
